<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="mobileHeader">
      <p>
        <span>进仓单号：{{ list.deliveryOrdeNo }}</span>
      </p>
      <p>
        <span>参考单号：{{ list.orgCustomerNo }}</span>
      </p>
      <p>
        <span>收货单号：{{ list.batchCode }}</span>
      </p>
      <p>
        <span>收货日期：{{ list.createTimeDesc }}</span>
      </p>
      <p>
        <span>收货人： {{ list.createUser }}</span>
        <span>收货箱数：{{ list.boxCount }}</span>
      </p>
    </div>

    <div class="sign-item">
      <div class="signInDetail-btnBox">
        <ul>
          <li style="margin-top: 10px">
            <span>库位</span>
            <div style="width:90%">
            <van-field
              size="small"
              v-model="list.locationCode"
              placeholder="库位"
              right-icon="scan"
              @click-right-icon="scan"
              @focus="storageFocus"
              @input="storageChange"
              ref="storage"
            />
				</div>
          </li>
          <li style="margin-top: 10px">
            <span>备注</span>
            <van-field
              v-model="list.remark"
              style="margin-left: 10px"
              rows="2"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="请输入备注"
              show-word-limit
              ref="remark"
            />
          </li>
        </ul>
      </div>
      <button class="signInDetail-receipt" @click="submit">确认上架</button>
    </div>
    <van-popup v-model="showPicker" round position="bottom" :overlay="false">
			<van-picker
				show-toolbar
				confirm-button-text="确认"
				cancel-button-text="取消"
				:columns="columns"
				@cancel="showPicker = false"
				@confirm="onConfirm"
				:loading="loading"
				:item-height="30"
				:visible-item-count="5"
			/>
		</van-popup>
  </div>
</template>

<script>
import { Field, Toast, Popup, Picker } from "vant";
import util from "util/date";
import { getDeliveryNo, submitSignFor } from "@/api/mobile/jy-onTheShelves_api";
import { getWarehouseLocation } from '@/api/mobile/stock_api';
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      list: {},
      itemArr: ["本次签收数量"],
      showPicker: false,
      columns: [],
			containTailDisabled: false,
			loading: false,
			viewportHeight: 0,
			focusType: ''
    };
  },

  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "locationCode", a.resultStr);
        },
      });
    },
    onConfirm(val) {
			this.$set(this.list, 'locationCode', val)
			this.showPicker = false;
		},
    init() {
      const that = this
      window.addEventListener('resize',function(){
				if(that.viewportHeight - this.innerHeight > 50){ // 键盘弹起
					if(that.focusType === 'locationCode'){
						that.showPicker = false
					}
					const activeElement = document.activeElement
					if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA') {
						
						that.$nextTick(function(){
							that.$refs.storage.focus ? that.$refs.storage.scrollTop = 100 : that.$refs.boxCount.scrollTop = 100
						})
					}
				}else{ // 键盘收起
					if(that.focusType === 'locationCode'){
						that.showPicker = true
					}
				}
			},true)
      this.getDeliveryNo();
    },
    // 库位获取焦点
		storageFocus(){
			this.showPicker = true
			this.focusType = 'locationCode'
			this.storageChange()
		},

		storageChange(){
            const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;

			const {locationCode} = this.list
			const {warehouseId} = _warehouse

      		if(!locationCode) return

			const data = {locationCode:locationCode,warehouseId} 
			this.loading = true

			getWarehouseLocation(data).then(res=>{
				this.loading = false
				if(res.status === 200){
					const {response} = res

					try{
						let arr = []
						response.forEach((item)=>{
							arr.push(item.locationCode);
						})
						this.columns = arr
					}catch{}
				}else{
					Toast.fail(res.msg);
				}
			})
		},
    scan() {
			let that = this
			this.$wx.scanQRCode({
				needResult: 1,
				desc: 'scanQRCode desc',
				success: function (a) {
					that.$set(that.list,'locationCode',a.resultStr)
				}
			})
		},
    getDeliveryNo() {
      const { batchCode } = this.$route.query;
      const data = {
        batchCode,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getDeliveryNo(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.estimatedDate = util.formatDate.format(
              new Date(response.estimatedDate),
              "yyyy-MM-dd"
            );
          } catch {}
          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
     showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      if (!this.list.locationCode) {
        this.showsound(false);
        return Toast.fail("请输入库位");
      }
      const { tfPutOnStockID, locationCode, remark } = this.list;
      const data = {
        tfPutOnStockID,
        locationCode,
        remark,
      };

      Toast.loading({
        message: "上架中...",
        forbidClick: true,
      });

      submitSignFor(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          this.showsound(true);
          Toast.success("上架成功");
          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;

  > p {
    display: flex;

    > span {
      flex: 1;
    }
  }
}

.sign-item {
  background-color: #fbf9fe;
  padding: 10px;

  .signInDetail-content {
    font-size: 15px;
  }

  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }

    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }

    .van-cell {
      margin-left: 10px;
      border: 1px solid #adadad;
      flex: 1;
    }
  }
}

.signInDetail-receipt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  border: 0;
}

.btn {
  width: 35%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 14px;
  border: 0;
  height: 25px;
  line-height: 25px;
}

.sign-photo-box {
  margin: 5px 10px 10px;
  border: 1px solid #797979;
  box-sizing: border-box;
  padding: 10px;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.sign-photo-save {
  padding: 0 10px;
}

::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fl {
  flex: 1 1 0%;
  max-width: 100% !important;
}

.hidden {
  display: none;
}

@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>
